import React, { useState, useEffect } from 'react';

import { siteRegInputs } from './educationDataInputs';
import { prepareInput } from '../Input';
import { Button } from '~c/ui/Button';
import { FormMessage } from '~c/FormMessage';
import { updateUserData } from './utils';
import metrikaGoal from '../../../helpers/metrikaGoal';

export const EducationData = (props) => {
  const [formData, setFormData] = useState([]);
  const [isPending, setIsPending] = useState(false);
  const [warningMessages, setWarningMessages] = useState('');
  const regInputs = siteRegInputs;

  useEffect(() => {
    metrikaGoal('addFields');
  }, []);

  const {dataForEduServices} = props;

  if (!dataForEduServices.body) {
    return null;
  }

  const inputsBillet = regInputs.reduce((prevV, curV) => ({...prevV, [curV.name]: ''}), {});
  if (!formData.length) {
    const initData = dataForEduServices.body.map(({id, name, lastName}) => {
      return {id, name, lastName, inputs: inputsBillet};
    });
    setFormData(initData);
  }

  const changeInput = ({inputName, val, iId}) => {
   setFormData(formData.map((item) => {
     if (item.id === iId) {
       return {
         ...item,
         inputs: {
           ...item.inputs,
           [inputName]: val
         }
       };
     }
     return {...item};
   }));
  };

  const onSubmit = async (fillLater) => {
    if (isPending) return;

    if (fillLater) {
      metrikaGoal('fillAfter');
      updateUserData(formData);
      props.nextStep();
    } else {
      const totalNumberFilled = formData.reduce((totalNumber, student) => {
        if (student.inputs) {
          return totalNumber + Object.values(student.inputs).reduce((numberOfFilled, input) => {
            return input ? numberOfFilled + 1 : numberOfFilled;
          }, 0);
        }
        return totalNumber;
      }, 0);

      if (totalNumberFilled === 0) {
        setWarningMessages('Вы не заполнили ни одного поля');
      } else {
        const totalNumberFields = formData.reduce((totalNumber, student) => {
          if (student.inputs) {
            return totalNumber + Object.values(student.inputs).length;
          }
          return totalNumber;
        }, 0);

        setWarningMessages('');
        setIsPending(true);
        const response = await updateUserData(formData);
        setIsPending(false);

        const numberSuccessRequests = response.reduce((prev, responseItem) => {
          if (responseItem && responseItem.status === 'success') {
            return prev + 1;
          }
          return prev;
        }, 0);

        const numberUsersWithFields = formData.reduce((prev, fDItem) => {
          if (fDItem.inputs) {
            return prev + 1;
          }
          return prev;
        }, 0);

        if (numberUsersWithFields === numberSuccessRequests) {
          if (totalNumberFilled === totalNumberFields) {
            metrikaGoal('fillAll');
            props.setFillLater(false);
            props.nextStep();
          } else {
            setWarningMessages('Ваши данные успешно сохранены');
          }
        } else {
          const newFormData = formData.map((formItem) => {
            const errorData = response.find((responseItem) => {
              return responseItem && responseItem.id === formItem.id && responseItem.status === "error";
            });

            if (errorData) {
              return {...formItem, inputs: null, errors: errorData.errors.map(({message}) => message)};
            }
            return formItem;
          });

          setFormData(newFormData);
        }
      }
    }
  };

  const numberErroneousUsers = formData.reduce((prev, fDItem) => {
    if (fDItem && fDItem.errors) {
      return prev + 1;
    }
    return prev;
  }, 0);

  return (
    <div className="registration">
      <h4 className="heading heading--2 heading--reverse">
        Данные для образовательных услуг
      </h4>
      <FormMessage className='registration__form-message' extraClass="warning">
        Данные поля необходимы
        <a className="form-message__highlight" target="blank" href="/event/educational-documents">&nbsp;по требованиям Министерства Образования РФ&nbsp;</a>
        для заключения договора и оказания образовательных услуг. Вы можете заполнить их сейчас или вернуться к заполнению позже в Личном кабинете.
      </FormMessage>
      <div className="registration__form">
        {(dataForEduServices && !!formData.length) && (
          formData.map(({id, name, lastName, inputs, errors}) => {
            return (
              <React.Fragment key={id}>
                {dataForEduServices.visualType === 'students' && (
                  <div className="registration__student-name heading heading--2 heading--reverse">{lastName} {name}</div>
                )}
                {errors ? (
                  <FormMessage extraClass="error">
                    {errors.map(error => (
                      <p className="form-message__p" key={error}>
                        {error}
                      </p>
                    ))}
                  </FormMessage>
                ) : (
                  <div className="inp-wrap">
                    {regInputs?.map(input =>
                      prepareInput({
                        ...input,
                        value: inputs[input.name],
                        onChangeCallback: (inputName, val) => changeInput({inputName, val, iId: id}),
                      }),
                    )}
                  </div>
                )}
              </React.Fragment>
            );
          })
        )}
      </div>
      <div className="separate" />
      {warningMessages && (
        <FormMessage className='registration__form-message' extraClass="warning">
          {warningMessages}
        </FormMessage>
      )}
      <div className="registration__btns">
        {numberErroneousUsers !== formData.length ? (
          <>
            <Button
              onClick={() => onSubmit(true)}
              extraClass='outline'
            >
              Заполнить позже
            </Button>
            <Button
              isPending={isPending}
              onClick={() => onSubmit(false)}
            >
              Сохранить
            </Button>
          </>
        ) : (
          <Button
            onClick={() => onSubmit(true)}
            extraClass='outline'
          >
            Завершить регистрацию
          </Button>
        )}
      </div>
    </div>
  );
};
